import authHeader from "../../services/authHeader";

const { ENDPOINT_API } = window.config;

const ENDPOINT_ODISEA_API = window.REACT_APP_API_URL || window.config.ENDPOINT_ODISEA_API;

export const ENDPOINT_DEPOT = ENDPOINT_ODISEA_API + '/redatamQueries/files';

export async function getMainConfig (callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  await fetch(`${ENDPOINT_ODISEA_API}/mainConfig`, requestOptions)
    .then( response => response.text() )
    .then( response => {
      response = JSON.parse(response);
      response.enabledDA = JSON.parse(response.enabledDA);
      return response;
    })
    .then( (r) => callback(r) )
    .catch(error => console.log('error', error));
};

export async function getLayersConfig (callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  await fetch(`${ENDPOINT_ODISEA_API}/layersConfig`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function getPageContent (callback, pageCode) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  await fetch(`${ENDPOINT_ODISEA_API}/pageContent/${pageCode}`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function getAllLinks (callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  await fetch(`http://localhost:1235/redweb/links/list/es`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function getBannerLinks (callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  await fetch(`${ENDPOINT_ODISEA_API}/links/banner`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function getFooterLinks (callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  await fetch(`${ENDPOINT_ODISEA_API}/links/footer`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function getAllForms (callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  await fetch(`http://localhost:1235/redweb/formweb/list/1`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export function getSegregationVariables() {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        ...authHeader()
    },
  };

  return fetch(`${ENDPOINT_ODISEA_API}/segregationVariables`, requestOptions)
    .then(response => {
      if (!response.ok) {
        // Check for 401 Unauthorized or other HTTP errors
        throw new Error(`HTTP error status: ${response.status}`);
      }
      return response.json();
    })
    .catch(error => {
      console.error('Failed to fetch derived variables:', error);
      throw error; // Rethrow to allow catching the error outside this function
    });
};

export function getSegregationSelections() {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        ...authHeader()
    },
  };

  return fetch(`${ENDPOINT_ODISEA_API}/segregationSelections`, requestOptions)
    .then(response => {
      if (!response.ok) {
        // Check for 401 Unauthorized or other HTTP errors
        throw new Error(`HTTP error status: ${response.status}`);
      }
      return response.json();
    })
    .catch(error => {
      console.error('Failed to fetch derived variables:', error);
      throw error; // Rethrow to allow catching the error outside this function
    });
};

export function getDerivedVariables() {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        ...authHeader()
    },
  };

  return fetch(`${ENDPOINT_ODISEA_API}/derivedVariables`, requestOptions)
    .then(response => {
      if (!response.ok) {
        // Check for 401 Unauthorized or other HTTP errors
        throw new Error(`HTTP error status: ${response.status}`);
      }
      return response.json();
    })
    .catch(error => {
      console.error('Failed to fetch derived variables:', error);
      throw error; // Rethrow to allow catching the error outside this function
    });
};

export function getFilterVariables() {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        ...authHeader()
    },
  };

  return fetch(`${ENDPOINT_ODISEA_API}/filterVariables`, requestOptions)
    .then(response => {
      if (!response.ok) {
        // Check for 401 Unauthorized or other HTTP errors
        throw new Error(`HTTP error status: ${response.status}`);
      }
      return response.json();
    })
    .catch(error => {
      console.error('Failed to fetch derived variables:', error);
      throw error; // Rethrow to allow catching the error outside this function
    });
};

export async function getResources (callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
      "Content-Type": "application/json",
      'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/resources`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function updateMainConfig (JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    headers: { "Content-Type": "application/json", 'accept': 'application/json'},
    origin: true,
    redirect: 'follow',
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/mainConfig`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updateBannerLink (id, JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/links/banner/${id}`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updateFooterLink (id, JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/links/footer/${id}`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updatePageContent (JSONcontent, page) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/pageContent/${page}`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updateFilterVariable (id, JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/filterVariables/${id}`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updateDerivedVariable (id, JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/derivedVariables/${id}`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updateSegregationVariable (id, JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/segregationVariables/${id}`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updateSegregationSelection (id, JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/segregationSelections/${id}`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function updateLayersConfig (JSONcontent) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    headers: { "Content-Type": "application/json", 'accept': 'application/json'},
    origin: true,
    redirect: 'follow',
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/layersConfig`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function deleteBannerLink (id) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/links/banner/${id}`, requestOptions)
    .then( response => response.text() )
    //.then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function deleteFilterVariable (id) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/filterVariables/${id}`, requestOptions)
    .then( response => response.text() )
    //.then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function deleteDerivedVariable (id) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/derivedVariables/${id}`, requestOptions)
    .then( response => response.text() )
    //.then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function deleteSegregationVariable (id) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/segregationVariables/${id}`, requestOptions)
    .then( response => response.text() )
    //.then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function deleteSegregationSelection (id) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/segregationSelections/${id}`, requestOptions)
    .then( response => response.text() )
    //.then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function deleteResource (name) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/resources/${name.toLowerCase().replaceAll(' ', '-')}`, requestOptions)
    .then( response => response.text() )
    //.then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function addFilterVariables (JSONcontent) {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/filterVariables`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function addDerivedVariables (JSONcontent) {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/derivedVariables`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function addSegregationVariables (JSONcontent) {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/segregationVariables`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function addSegregationSelections (JSONcontent) {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/segregationSelections`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

export async function addBannerLinks (JSONcontent) {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/links/banner`, requestOptions)
      .then( response => response.text() )
      //.then( callback )
      .catch(error => console.log('error', error));
};

// PAGES:

export const getPagesByLang = (lang, callback) => {
  fetch(ENDPOINT_ODISEA_API + '/pages/', {
      method: 'GET',
      credentials: 'same-origin',
      origin: true,
  })
      .then( response => response.text() )
      .then( callback )
      .catch( error => console.log('error', error) );
}

export async function addObservatoryPage (JSONcontent, callback) {

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

 await fetch(`${ENDPOINT_ODISEA_API}/pages/`, requestOptions)
      .then( response => response.text() )
      .then( callback )
      .catch(error => console.log('error', error));
};

export async function updateObservatoryPage (pageId, JSONcontent, callback) {

  const requestOptions = {
    method: 'PUT',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
    body: JSON.stringify(JSONcontent)
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/pages/${pageId}`, requestOptions)
      .then( response => response.text() )
      .then( callback )
      .catch(error => console.log('error', error));
};

export async function getPageByCode (id, callback) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    origin: true,
    redirect: 'follow',
    headers: {
        "Content-Type": "application/json",
        'Accept':       'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/pages/${id}`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function deletePage (id, callback) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'include',
    origin: true,
    redirect: 'follow'
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/pages/${id}`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export async function uploadResource (name, fileName, fileData, callback) {
    
  let form = new FormData();

  form.append('file', fileData);
    
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    origin: true,
    redirect: 'follow',
    headers: {
      'accept': 'application/json',
      //'Content-Type': 'multipart/form-data',
    },
    body: form
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_ODISEA_API}/resources/${name}`, requestOptions)
    .then( response => response.text() )
    .then( (r) => callback(JSON.parse(r)) )
    .catch(error => console.log('error', error));
};

export const updatePass = async ( old_pass, new_pass, callback ) => {
  await fetch( ENDPOINT_ODISEA_API + '/update-password', {
      method: 'POST',
      credentials: 'include',
      origin: true,
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
          old_password: old_pass,
          new_password: new_pass
      }),
      redirect: 'follow'
  })
  .then( response => response.text() )
  .then( async (r) => {return await callback(JSON.parse(r))} )
  .catch(error => console.log('error', error));
}

export const execSPC = (dbname, value, callback) => {
  var raw = "{\"alias\": \"" + dbname + "\",\r\n\"display\": false,\r\n\"spc\": \"" + value + "\" }";

  fetchWithTimeout(ENDPOINT_API, {
      method: 'POST',
      credentials: 'same-origin',
      // credentials: 'include',
      origin: true,
      headers: { "Content-Type": "text/plain" },
      body: raw,
      redirect: 'follow'
  })
      .then( response => response.text() )
      .then( callback )
      .catch(error => console.log('error', error));
}

async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 3*60000 } = options;
  
  const controller = new AbortController();
  const id = setTimeout(() => {
    controller.abort();
    alert('La consulta ha tardado más del tiempo máximo en procesar. Intenta realizarla por partes o comunícate con el administrador.');
    window.history.back();
  }, timeout);
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal  
  });
  clearTimeout(id);
  return response;
}

export async function executeSegregation (JSONcontent, callback) {

  const requestOptions = {
    method: 'POST',
    headers: { "Content-Type": "application/json", 'accept': 'application/json'},
    // credentials: 'include',
    origin: true,
    redirect: 'follow',
    body: JSON.stringify(JSONcontent)
  };

  await fetch(`${ENDPOINT_ODISEA_API}/redatamQueries/segregation/execute`, requestOptions)
      .then( response => response.text() )
      .then( callback )
      .catch(error => console.log('error', error));
};

export async function executeMigration (JSONcontent, callback) {

  const requestOptions = {
    method: 'POST',
    headers: { "Content-Type": "application/json", 'accept': 'application/json'},
    // credentials: 'include',
    origin: true,
    redirect: 'follow',
    body: JSON.stringify(JSONcontent)
  };

  await fetch(`${ENDPOINT_ODISEA_API}/redatamQueries/migration/execute`, requestOptions)
      .then( response => response.text() )
      .then( callback )
      .catch(error => console.log('error', error));
};

export async function executeMobility (JSONcontent, callback) {

  const requestOptions = {
    method: 'POST',
    headers: { "Content-Type": "application/json", 'accept': 'application/json'},
    // credentials: 'include',
    origin: true,
    redirect: 'follow',
    body: JSON.stringify(JSONcontent)
  };

  await fetch(`${ENDPOINT_ODISEA_API}/redatamQueries/mobility/execute`, requestOptions)
      .then( response => response.text() )
      .then( callback )
      .catch(error => console.log('error', error));
};
